import React from 'react'

const Homehrmanagements = () => {
  return (
    <section id="more-features" className="more-features section">
      <div className="container">
        <div className="row justify-content-around gy-4">
          <div className="col-lg-6 d-flex flex-column justify-content-center order-2 order-lg-1">
            <h3>HR MANAGEMENT SIMPLIFIED</h3>
            <p /><p>Adapt to new realities, work faster and smarter. Determine a defined future of work for your organization with a strong, flexible, global HR solution.Explore the RapidHR Product</p><p />
            <div className="row">
              <div className="col-lg-6 icon-box d-flex">
                <i className="bi bi-easel flex-shrink-0" />
                <div>
                  <p>Easy access to documents and information.</p>
                </div>
              </div>{/* End Icon Box */}
              <div className="col-lg-6 icon-box d-flex">
                <i className="bi bi-patch-check flex-shrink-0" />
                <div>
                  <p>An employee database that scales.</p>
                </div>
              </div>{/* End Icon Box */}
              <div className="col-lg-6 icon-box d-flex">
                <i className="bi bi-brightness-high flex-shrink-0" />
                <div>
                  <p>Automation of HR processes.</p>
                </div>
              </div>{/* End Icon Box */}
              <div className="col-lg-6 icon-box d-flex">
                <i className="bi bi-brightness-high flex-shrink-0" />
                <div>
                  <p>Automation of HR processes.</p>
                </div>
              </div>{/* End Icon Box */}
            </div>
          </div>
          <div className="features-image col-lg-5 order-1 order-lg-2">
            <img src="https://sigohrmlpadmin.loopring.in/front/images/homehrmanagements/89220.png" alt />
          </div>
        </div>
      </div>
    </section>

  )
}

export default Homehrmanagements
